import type { PsdcApiError } from '~/utilities/pyscript-api-models';
import { i18n } from '~/modules/i18n';

const { t } = i18n.global;

/**
 * Checks if an error variable is a PSDC API error.
 * Use this in catch blocks for type narrowing.
 */
export function isPsdcApiError(error: unknown): error is PsdcApiError {
  return Boolean(error && typeof error === 'object' && 'message' in error && 'status' in error);
}

export function getErrorMessage(error: unknown): string {
  if (isPsdcApiError(error)) {
    return error.message;
  } else {
    return t('errors.generic');
  }
}
